import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AccountingfirmRoutingModule } from './accountingfirm-routing.module'
import { AccountingfirmComponent } from './accountingfirm/accountingfirm.component'
import { CustomTranslateModule } from '@flowaccount/landing'
import { CoreModule } from '../../core.module'

import { BecomeOurPartnerComponent } from './become-our-partner/become-our-partner.component'
import { PartnerIntroComponent } from './become-our-partner/intro/intro.component'
import { PartnerGrowthComponent } from './become-our-partner/growth/growth.component'
import { PartnerFeatureComponent } from './become-our-partner/feature/feature.component'
import { PartnerTestimonialComponent } from './become-our-partner/testimonial/testimonial.component'
import { PartnerTestimonialVdoComponent } from './become-our-partner/testimonial-vdo/testimonial-vdo.component'
import { PartnerBenefitsComponent } from './become-our-partner/benefits/benefits.component'
import { PartnerRegisterComponent } from './become-our-partner/register/register.component'
import { PartnerCalendarComponent } from './become-our-partner/calendar/calendar.component'
import { TestimonialCardComponent } from './become-our-partner/testimonial/testimonial-card/testimonial-card.component'
import { FindAccountingfirmComponent } from './find-accountingfirm/find-accountingfirm.component'
import { IntroComponent } from './find-accountingfirm/intro/intro.component'
import { BenefitsComponent } from './find-accountingfirm/benefits/benefits.component'
import { IntroduceComponent } from './find-accountingfirm/introduce/introduce.component'
import { RegisterComponent } from './find-accountingfirm/register/register.component'
import { FindComponent } from './find-accountingfirm/find/find.component'
import { PaginationModule } from 'ngx-bootstrap/pagination'
import { FormsModule } from '@angular/forms'
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper'
import { TestimonialPartnerComponent } from './find-accountingfirm/testimonial-partner/testimonial-partner.component'

import { CertificatePartnersComponent } from './become-our-partner/certificate-partners/certificate-partners.component'
import { SpecialGiftComponent } from './become-our-partner/special-gift/special-gift.component'
import { PointActivityComponent } from './become-our-partner/point-activity/point-activity.component'
import { PerkForPartnerComponent } from './become-our-partner/perk-for-partner/perk-for-partner.component'
import { VideoPartnerConnectComponent } from './become-our-partner/video-partner-connect/video-partner-connect.component'
import { FindRecommendPartnerInfomationComponent } from './find-accountingfirm/find-recommend-partner-infomation/find-recommend-partner-infomation.component'
import { VideoPartnerPromiseComponent } from './become-our-partner/video-partner-promise/video-partner-promise.component'
import { PartnerFlowaccountFormComponent } from './become-our-partner/partner-flowaccount-form/partner-flowaccount-form.component'
import { PartnerRoadshowComponent } from './become-our-partner/partner-roadshow/partner-roadshow.component'

// swiper
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: true,
  },
}

@NgModule({
  imports: [
    // SwiperModule,
    CommonModule,
    CoreModule.forRoot(),
    AccountingfirmRoutingModule,
    CustomTranslateModule.forChild({ path: 'accountingfirm' }),
    PaginationModule.forRoot(),
    FormsModule,
  ],
  declarations: [
    AccountingfirmComponent,
    BecomeOurPartnerComponent,
    PartnerIntroComponent,
    PartnerGrowthComponent,
    PartnerFeatureComponent,
    PartnerTestimonialComponent,
    PartnerTestimonialVdoComponent,
    PartnerBenefitsComponent,
    PartnerRegisterComponent,
    PartnerCalendarComponent,
    TestimonialCardComponent,
    FindAccountingfirmComponent,
    IntroComponent,
    BenefitsComponent,
    IntroduceComponent,
    RegisterComponent,
    FindComponent,
    TestimonialPartnerComponent,

    CertificatePartnersComponent,
    SpecialGiftComponent,
    PointActivityComponent,
    PerkForPartnerComponent,
    VideoPartnerConnectComponent,
    FindRecommendPartnerInfomationComponent,
    VideoPartnerPromiseComponent,
    PartnerFlowaccountFormComponent,
    PartnerRoadshowComponent,
  ],

  providers: [
    // swiper
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class AccountingfirmModule {}
